import ProfileService from '@/services/ProfileService'

const createProfilesModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    profiles: [],
    profile: null,
    filter: ''
  },
  actions: {
    getProfile: ({ commit, state }) => {
      ProfileService.getProfile()
        .then((data) => {
          commit('SET_PROFILE', { profile: data.profile })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    getProfiles: ({ commit, state }) => {
      ProfileService.getProfiles(state.pageSize, state.page, state.filter)
        .then((data) => {
          commit('SET_PROFILES', { profiles: data.profiles })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ commit, dispatch }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getProfiles')
    },
    setFilter: ({ dispatch, commit }, filter) => {
      commit('SET_PAGE', { page: 1 })
      commit('SET_FILTER', { filter })
      dispatch('getProfiles')
    }
  },
  getters: {
    profile: (state) => state.profile,
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_PROFILE: (state, { profile }) => {
      state.profile = profile
    },
    SET_PROFILES: (state, { profiles }) => {
      state.profiles = profiles
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_FILTER: (state, { filter }) => {
      state.filter = filter
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createProfilesModule
